import styled from "styled-components";

import { Grid } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";

import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
// import SaveAltIcon from "@mui/icons-material/SaveAlt";
import ErrorIcon from "@mui/icons-material/Error";

import font from "src/styles/font";
import device from "src/styles/device";
import { DarkGrey, GreyStroke, Yellow } from "src/styles/color";
import { checkNotEmpty } from "src/common";

import Button from "src/components/core/Button";
import TextField from "src/components/core/TextField";
import UploadImage from "src/components/upload/dropzone/UploadImage";
import { useState } from "react";

const SpanTitle = styled.div`
  font-size: ${font.size.md};
  font-weight: 400;
  line-height: 24px;

  @media ${device.mobileL} {
    font-size: ${font.size.sm};
    font-weight: 500;
  }
`;

const WrapperBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media ${device.mobileL} {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;

    .MuiFormControl-root {
      width: 100%;
      min-width: unset;
      max-width: unset;
      min-height: 40px;
    }
  }
`;

const StyledSelect = styled(Select)`
  border-radius: 16px;
  /* text-align: center; */

  .MuiSelect-select {
    padding: 12px 16px;
  }
  &.MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${DarkGrey};
  }
  .Mui-disabled,
  &.Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color: ${GreyStroke};
  }

  @media ${device.mobileL} {
    .MuiSelect-select {
      padding: 8px 12px;
    }
  }
`;

const StyledDatePicker = styled(DatePicker)`
  .MuiOutlinedInput-root {
    padding-right: 12px;
  }
  &.MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${DarkGrey};
  }
  .Mui-disabled,
  &.Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color: ${GreyStroke};
  }
`;

const UploadBox = styled.div`
  width: 100%;
  padding-top: 8px;

  @media ${device.mobileL} {
    padding-top: 0;
  }
`;

const WrapperUpload = styled.div`
  width: 100%;
  max-width: 350px;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const WrapperUploadImage = styled.div`
  /* max-width: 300px;
  height: auto;
  max-height: 300px; */
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const WrapperImgSlip = styled.div`
  width: 100%;
  max-width: 300px;
  height: auto;
`;

const ImgSlip = styled.img`
  width: 100%;
  height: 100%;
  /* max-height: 300px; */
  object-fit: contain;
`;

const WarningText = styled.div`
  width: 100%;
  /* margin-top: 12px; */
  display: flex;
  justify-content: center;
  gap: 8px;

  span {
    padding-top: 3px;
    font-size: ${font.size.xs};
    color: ${DarkGrey};
  }
`;

const PaymentComponent = ({
  isDeposit = false,
  updateOrder,
  setUpdateOrder,
}) => {
  const paymentStatus = [
    { label: "จ่ายเต็มจำนวน", value: "paid" },
    { label: "มัดจำ", value: "deposit" },
  ];

  const paymentTypes = [
    { label: "Promptpay", value: "promptpay" },
    { label: "โอนบัญชี XSURFACE", value: "transfer" },
    // { label: "บัตรเครดิต / เดบิต", value: "credit-card" },
  ];

  const [paymentData, setPaymentData] = useState({
    slipdate: "",
    slipImage: "",
  });

  const handleSlipImage = (fileCallBlack) => {
    const dataUp = updateOrder;

    if (isDeposit) {
      setUpdateOrder({ ...dataUp, paySlipOtherImage: fileCallBlack });
    } else {
      setUpdateOrder({ ...dataUp, paySlipImage: fileCallBlack });
    }

    setPaymentData({ ...paymentData, slipImage: fileCallBlack });
  };

  const handleSlipDate = (date) => {
    if (isDeposit) {
      setUpdateOrder({ ...updateOrder, slipOtherDate: date });
    } else {
      setUpdateOrder({ ...updateOrder, slipDate: date });
    }

    setPaymentData({ ...paymentData, slipdate: date });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <WrapperBox>
          <SpanTitle>การชำระเงิน</SpanTitle>

          <FormControl
            sx={{ minWidth: 220, alignSelf: "flex-end" }}
            error={!checkNotEmpty(updateOrder?.status)}
            // disabled={isDeposit}
            disabled
          >
            <StyledSelect
              labelId="payment-status-select-label"
              id="payment-status-select"
              value={updateOrder.status}
              onChange={(e) => {
                setUpdateOrder({ ...updateOrder, status: e.target.value });
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    borderRadius: 4,
                    ".MuiList-root": { padding: 0 },
                    ".MuiMenuItem-root": {
                      minHeight: { sm: 48, xs: 40 },
                      px: { sm: 2, xs: 1.5 },
                      py: { sm: 1.5, xs: 1 },
                      fontSize: { sm: font.size.md, xs: font.size.sm },
                    },
                  },
                },
              }}
            >
              {paymentStatus.map((option) => (
                <MenuItem value={option.value}>{option.label}</MenuItem>
              ))}
            </StyledSelect>
          </FormControl>
        </WrapperBox>
      </Grid>

      <Grid item xs={12}>
        <WrapperBox>
          <SpanTitle>ช่องทางการชำระเงิน</SpanTitle>

          <FormControl
            sx={{ minWidth: 220, alignSelf: "flex-end" }}
            error={!checkNotEmpty(updateOrder?.paymentType)}
          >
            <StyledSelect
              labelId="payment-type-select-label"
              id="payment-type-select"
              displayEmpty
              value={updateOrder.paymentType || ""}
              onChange={(e) => {
                setUpdateOrder({ ...updateOrder, paymentType: e.target.value });
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    borderRadius: 4,
                    ".MuiList-root": { padding: 0 },
                    ".MuiMenuItem-root": {
                      minHeight: { sm: 48, xs: 40 },
                      px: { sm: 2, xs: 1.5 },
                      py: { sm: 1.5, xs: 1 },
                      fontSize: { sm: font.size.md, xs: font.size.sm },
                    },
                  },
                },
              }}
            >
              <MenuItem disabled value="" sx={{ display: "none" }}>
                <em>เลือกช่องทางการชำระเงิน</em>
              </MenuItem>
              {paymentTypes.map((option) => (
                <MenuItem value={option.value}>{option.label}</MenuItem>
              ))}
            </StyledSelect>
          </FormControl>
        </WrapperBox>
      </Grid>

      <Grid item xs={12}>
        <WrapperBox>
          <SpanTitle>วันที่ชำระเงิน</SpanTitle>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <StyledDatePicker
              inputFormat="DD/MM/YYYY"
              value={paymentData?.slipdate}
              adapterLocale="th"
              onChange={(value) => {
                handleSlipDate(value.$d);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  variant="outlined"
                  sx={{
                    // my: 2,
                    maxWidth: 220,
                  }}
                  error={paymentData?.slipdate === ""}
                />
              )}
            />
          </LocalizationProvider>
        </WrapperBox>
      </Grid>

      {/* <Grid item xs={12}>
        <TextField
          variant="outlined"
          fullWidth
          label="Ref Pay No."
          InputLabelProps={{ shrink: true }}
          InputProps={{
            readOnly: true,
          }}
          value={updateOrder.refPayNo}
        />
      </Grid> */}

      <Grid item xs={12}>
        <UploadBox>
          <WrapperUpload>
            {checkNotEmpty(paymentData?.slipImage) ? (
              <>
                <IconButton
                  sx={{
                    padding: "3px",
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    zIndex: 10,
                    backgroundColor: "#d9d9d999",
                    ":hover": { backgroundColor: "#d9d9d9db" },
                  }}
                  onClick={() => {
                    handleSlipImage("");
                  }}
                >
                  <CloseIcon sx={{ color: "#e04132", cursor: "pointer" }} />
                </IconButton>

                <UploadImage
                  callBackFile={(fileCallBlack) => {
                    handleSlipImage(fileCallBlack);
                  }}
                  closeAlert={false}
                >
                  <WrapperUploadImage>
                    <WrapperImgSlip>
                      <ImgSlip
                        src={paymentData?.slipImage?.fileData}
                        alt="slipImage"
                      />
                    </WrapperImgSlip>
                  </WrapperUploadImage>
                </UploadImage>

                {/* <Button
                  variant="outlined"
                  color="secondary"
                  startIcon={<SaveAltIcon />}
                >
                  ดาวน์โหลด
                </Button> */}
              </>
            ) : (
              <>
                <UploadImage
                  callBackFile={(fileCallBlack) => {
                    handleSlipImage(fileCallBlack);
                  }}
                  closeAlert={false}
                >
                  <WrapperUploadImage>
                    <Button
                      variant="outlined"
                      color="secondary"
                      startIcon={<AddIcon />}
                    >
                      แบบหลักฐานการชำระเงิน
                    </Button>
                  </WrapperUploadImage>
                </UploadImage>

                <WarningText sx={{ mt: "14px" }}>
                  <ErrorIcon sx={{ color: Yellow }} />

                  <span>ขนาดไฟล์สูงสุดไม่เกิน 4 MB</span>
                </WarningText>
              </>
            )}
          </WrapperUpload>
        </UploadBox>
      </Grid>
    </Grid>
  );
};

export default PaymentComponent;
